// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hp3M","field":"styles_field__uu3nA","fieldCol":"styles_fieldCol__pZ-AJ","diffCol":"styles_diffCol__K9_0H","diff":"styles_diff__2Ti3e"};